
import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },

  routes: [

    {


      path: '/',
      component: () => import('./layouts/main/Main.vue'),
      children: [


        {
          path: i18n.t('menu.dashboard.url'),
          name: i18n.t('menu.dashboard.name'),
          component: () => import('./views/DashboardMain.vue'),
          meta: {

            rule: i18n.t('menu.dashboard.meta.rule')
          },
          beforeEnter(to, from, next) {
            const userRoles = JSON.parse(localStorage.getItem('userRoles'))
            if (userRoles && userRoles[0].name === 'user') {
              router.app.$nextTick(() => {
                router.app.$vs.loading.close()
              })
              next({ path: '/home', replace: true })

            } else if (userRoles && userRoles[0].name === 'blog') {
              next({ path: '/blogs', replace: true })
            } else if (userRoles && userRoles[0].name === 'teacher') {
              next({ path: '/dashboard', replace: true })
            } else {
              next()
            }

          }

        },

        {
          path: 'demo-requests',
          name: 'Demo Requests',
          component: () => import('./views/demo/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Demo Requests', active: true }
            ],
            pageTitle: 'Demo Requests',
            rule: 'admin'
          }
        },
        {
          path: 'center-aws/:centerId',
          name: 'Center View',
          component: () => import('./views/aws-centers/CenterProfile2.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Centers', url: '/centers-list' },
              { title: 'Center View', active: true }
            ],
            parent: 'centers',
            pageTitle: 'Center View',
            rule: 'admin'
          }
        },
        {
          path: 'aws-center-databases',
          name: 'Center Databases',
          component: () => import('./views/aws-centers/Databases.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AWS Center Databases', active: true }
            ],
            pageTitle: 'AWS Center Databases',
            rule: 'admin'
          }
        },
        {
          path: 'center/:centerId',
          name: 'Center Profile',
          component: () => import('./views/centers/CenterProfile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Centers', url: '/centers-list' },
              { title: 'Center View', active: true }
            ],
            parent: 'centers',
            pageTitle: 'Center View',
            rule: 'admin'
          }
        },
        {
          path: 'customer-websites',
          name: 'Customer Websites',
          component: () => import('./views/websites-management/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Websites', active: true }
            ],
            pageTitle: 'Websites',
            rule: 'admin'
          }
        },


        {
          path: 'main/tickets/:status?',
          name: 'Main Tickets',
          component: () => import('./views/main/tickets/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tickets', active: true }
            ],
            pageTitle: 'Tickets',
            rule: 'kvsupport'
          }
        },
        {
          path: 'main/ticket/:ticketId',
          name: 'Main Ticket Profile',
          component: () => import('@/views/main/tickets/Profile.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Tickets',
                'url': '/main/tickets'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Ticket View',
            rule: 'kvsupport'
          }
        },
        {
          path: 'main/incidents',
          name: 'incidents',
          component: () => import('@/views/main/incidents/Incidents.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', active: true }
            ],
            pageTitle: 'Incidents',
            rule: 'kvsupport'
          }
        },
        {
          path: 'main/incident/:id',
          name: 'view-main-incident',
          component: () => import('@/views/main/incidents/ViewIncident.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', url: '/main/incidents' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Incident View',
            rule: 'kvsupport'
          }
        },
        {
          path: i18n.t('menu.students.url'),
          name: i18n.t('menu.students.name'),
          component: () => import('@/views/students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students.meta.pageTitle'),
            rule: i18n.t('menu.students.meta.rule'),
            parent: 'students'
          }
        },

        {
          path: i18n.t('menu.students_user.url'),
          name: i18n.t('menu.students_user.name'),
          component: () => import('@/views/user-students/DataListView.vue'),
          meta: {
            pageTitle: i18n.t('menu.students_user.meta.pageTitle'),
            rule: i18n.t('menu.students_user.meta.rule')
          }
        },
        {
          path: i18n.t('menu.students_teacher.url'),
          name: i18n.t('menu.students_teacher.name'),
          component: () => import('@/views/teacher-students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students_teacher.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students_teacher.meta.pageTitle'),
            rule: i18n.t('menu.students_teacher.meta.rule')
          }
        },
        {
          path: i18n.t('menu.users.url'),
          name: i18n.t('menu.users.name'),
          component: () => import('@/views/cam-users/DataListView2.vue'),
          meta: {
            breadcrumb: i18n.t('menu.users.meta.breadcrumb'),
            pageTitle: i18n.t('menu.users.meta.pageTitle'),
            rule: i18n.t('menu.users.meta.rule'),
            parent: 'users'
          }
        },

        {
          path: i18n.t('menu.incidents.url'),
          name: i18n.t('menu.incidents.name'),
          component: () => import('@/views/incidents/Incidents.vue'),
          meta: {
            breadcrumb: i18n.t('menu.incidents.meta.breadcrumb'),
            pageTitle: i18n.t('menu.incidents.meta.pageTitle'),
            rule: i18n.t('menu.incidents.meta.rule')
          }
        },

        {
          path: '/centers-list',
          name: 'centers',
          component: () => import('@/views/centers/DataCentersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Centers', active: true }
            ],
            pageTitle: 'Centers',
            rule: 'kvsupport'
          }
        },
        {
          path: '/tickets/:status?',
          name: 'Tickets',
          component: () => import('./views/tickets/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tickets', active: true }
            ],
            pageTitle: 'Tickets',
            rule: 'manager'
          }
        },
        {
          path: '/ticket/:ticketId',
          name: 'Ticket Profile',
          component: () => import('@/views/tickets/Profile.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Tickets',
                'url': '/tickets'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            parent: 'tickets',
            pageTitle: 'Ticket View',
            rule: 'manager'
          }
        },
        {
          path: '/locations',
          name: 'Locations',
          component: () => import('./views/locations/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Locations', active: true }
            ],
            pageTitle: 'Locations',
            rule: 'kvsupport'
          }
        },
        {
          path: '/location/:locationId',
          name: 'Location Profile',
          component: () => import('@/views/locations/locationView.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'All Locations',
                'url': '/locations'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Location View',
            rule: 'kvsupport',
            parent: '/location'
          },
          children: [
            {
              path: 'rooms',
              name: 'location-rooms',
              component: () => import('@/views/rooms/LocationProgramsListView.vue'),
              meta: {
                breadcrumb: [
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent: 'rooms'
              }
            },
            {
              path: 'programs',
              name: 'location-programs',
              component: () => import('@/views/billing_programs/LocationProgramsListView.vue'),
              meta: {
                breadcrumb: [
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent: 'programs'
              }
            },
            {
              path: 'cameras',
              name: 'location-cameras',
              component: () => import('@/views/cameras/LocationCamerasListView.vue'),
              meta: {
                breadcrumb: [
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent: 'cameras'
              }
            },
            {
              path: 'managers',
              name: 'location-managers',
              component: () => import('@/views/locations/locationView.vue'),
              meta: {
                breadcrumb: [
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent: '/location'
              }
            },
            {
              path: 'camera-groups',
              name: 'location-camera-groups',
              component: () => import('@/views/locations/locationView.vue'),
              meta: {
                breadcrumb: [
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent: 'cameras'
              }
            },
            {
              path: 'settings',
              name: 'location-settings',
              component: () => import('@/views/locations/locationView.vue'),
              meta: {
                breadcrumb: [
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                parent: '/location',
                pageTitle: 'Location View',
                rule: 'kvsupport'

              }
            }


          ]
        },
        {
          path: '/rooms/:action?',
          name: 'Rooms',
          component: () => import('./views/rooms/programsListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rooms', active: true }
            ],
            pageTitle: 'Rooms',
            rule: 'manager'
          }
        },
        {
          path: '/billing_programs',
          name: 'billing_programs',
          component: () => import('./views/billing_programs/programsListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Programs', active: true }
            ],
            pageTitle: 'Programs',
            rule: 'manager'
          }
        },
        {
          path: '/cameras',
          name: 'Cameras',
          component: () => import('./views/cameras/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Cameras', active: true }
            ],
            pageTitle: 'Cameras',
            rule: 'manager'
          }

        },
        {
          path: '/schedules',
          name: 'Schedules',
          component: () => import('./views/schedules/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Camera Schedules', active: true }
            ],
            pageTitle: 'Camera Schedules',
            rule: 'manager'
          }
        },
        {
          path: '/student-tags',
          name: 'Tags',
          component: () => import('./views/student-tags/DataListTag.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Tags', active: true }
            ],
            pageTitle: 'Tags',
            rule: 'manager'
          }
        },
        {
          path: '/student-allergies',
          name: 'Allergies',
          component: () => import('./views/student-allergies/DataListAllergies.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Allergies', active: true }
            ],
            pageTitle: 'Allergies',
            rule: 'manager'
          }
        },
        {
          path: '/student-medications',
          name: 'Medications',
          component: () => import('./views/student-medications/DataListMedications.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Medications', active: true }
            ],
            pageTitle: 'Medications',
            rule: 'manager'
          }
        },
        {
          path: '/kvadmin-settings',
          name: 'KVAdmin Settings',
          component: () => import('./views/Settings/ThemeCustomizer'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'KVAdmin Settings', active: true }
            ],
            pageTitle: 'KVAdmin Settings',
            rule: 'admin'
          }
        },
        {
          path: '/onboarding',
          name: 'Onboarding',
          component: () => import('./views/Settings/OnBoarding'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Onboarding', active: true }
            ],
            pageTitle: 'Onboarding',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/utilities',
          name: 'Utilities',
          component: () => import('./views/Settings/Utilities'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', active: true }
            ],
            pageTitle: 'Utilities',
            rule: 'kvsupport'
          }
        },
        {
          path: '/advance-onboarding',
          name: 'Advance Onboarding',
          component: () => import('./views/Settings/AdOnBoarding'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Advance Onboarding', active: true }
            ],
            pageTitle: 'Advance Onboarding',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/sync-brightwheel',
          name: 'Sync Brightwheel',
          component: () => import('./views/Settings/SyncBrightwheel'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Sync Brightwheel', active: true }
            ],
            pageTitle: 'Sync Brightwheel',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/procare-import',
          name: 'Procare Desktop Import Students',
          component: () => import('./views/Settings/ProcareImport'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Procare Desktop Import', active: true }
            ],
            pageTitle: 'Procare Desktop Import',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/procare-import-staff',
          name: 'Procare Desktop Import Staff',
          component: () => import('./views/Settings/ProcareImportStaff'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Procare Desktop Import Staff', active: true }
            ],
            pageTitle: 'Procare Desktop Import Staff',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/send-custom-email',
          name: 'Send Email',
          component: () => import('./views/Settings/UtilityCustomEmail'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Send Email', active: true }
            ],
            pageTitle: 'Send Email',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/import-cameras',
          name: 'Import Cameras',
          component: () => import('./views/Settings/UtilityImportCameras'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Import Cameras', active: true }
            ],
            pageTitle: 'Import Cameras',
            rule: 'kvsupport',
            parent: 'utilities'
          }
        },
        {
          path: '/school_profile',
          name: 'School Profile',
          component: () => import('./views/Settings/School'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'School Profile', active: true }
            ],
            pageTitle: 'School Profile',
            rule: 'manager'
          }
        },

        {
          path: '/images',
          name: 'Images',
          component: () => import('./views/images/imagesListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Images', active: true }
            ],
            pageTitle: 'Images',
            rule: 'manager'
          }
        },
        {
          path: '/folder/:folder',
          name: 'folder',
          component: () => import('./views/images/FolderImageView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Images', url: '/images' },
              { title: 'Folder', active: true }
            ],
            pageTitle: 'Images',
            rule: 'admin'
          }
        },
        {
          path: '/announcements',
          name: 'Announcements',
          component: () => import('./views/messagings/Announcement.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Announcements', active: true }
            ],
            pageTitle: 'Announcements',
            rule: 'teacher'
          }
        },
        {
          path: '/messages',
          name: 'messages',
          component: () => import('./views/chat/Chat.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Messages', active: true }
            ],
            pageTitle: 'Messages',
            rule: 'user',
            no_scroll: true
          }

        },
        {
          path: '/create-dashboard',
          name: 'create dashboard',
          component: () => import('./views/customize-dashboard/own-dashboard/createDashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Create Dashboard', active: true }
            ],
            pageTitle: 'Create Dashboard',
            rule: 'manager'

          }
        },
        {
          path: '/edit-dashboard/:dashboardId',
          name: 'edit dashboard',
          component: () => import('./views/customize-dashboard/own-dashboard/updateDashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Edit Dashboard', active: true }
            ],
            pageTitle: 'Edit Dashboard',
            rule: 'manager'

          }
        },
        {
          path: '/messages-log',
          name: 'Messages Log',
          component: () => import('./views/messagings/MessageLogs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Messages Log', active: true }
            ],
            pageTitle: 'Messages Log',
            rule: 'teacher'
          }
        },
        {
          path: '/activities',
          name: 'Activities',
          component: () => import('./views/activities/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Activities', active: true }
            ],
            pageTitle: 'Activities',
            rule: 'teacher'
          }
        },
        {
          path: '/room-feed',
          name: 'Feed',
          component: () => import('./views/activities/DataRoomFeeds.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Feed', active: true }
            ],
            pageTitle: 'Feed',
            rule: 'teacher'
          }
        },

        {
          path: '/team/:role?',
          name: 'team',
          component: () => import('@/views/team/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Team', active: true }
            ],
            parent: 'team',
            pageTitle: 'Team',
            rule: 'manager'
          }
        },
        {
          path: '/manage-location/:tab?',
          name: 'Manage Location',
          component: () => import('./views/ManageLocation.vue'),
          meta: {
            rule: 'manager'
          }
        },

        {
          path: '/team-profile/:team',
          name: 'Team Profile',
          component: () => import('@/views/team/profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Team', url: '/team' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Team View',
            rule: 'manager',
            parent: 'team'
          }
        },
        {
          path: i18n.t('route.student_profile.url'),
          name: i18n.t('route.student_profile.name'),
          component: () => import('@/views/students/profile.vue'),
          meta: {
            breadcrumb: i18n.t('route.student_profile.meta.breadcrumb'),
            pageTitle: i18n.t('route.student_profile.meta.pageTitle'),
            rule: i18n.t('route.student_profile.meta.rule'),
            parent: 'students'
          }
        },
        {
          path: i18n.t('route.teacher_student_profile.url'),
          name: i18n.t('route.teacher_student_profile.name'),
          component: () => import('@/views/teacher-students/profile.vue'),
          meta: {
            breadcrumb: i18n.t('route.teacher_student_profile.meta.breadcrumb'),
            pageTitle: i18n.t('route.teacher_student_profile.meta.pageTitle'),
            rule: i18n.t('route.teacher_student_profile.meta.rule'),
            parent: 'teacher-students'

          }
        },
        {
          path: 'user/student/:studentId',
          name: 'User Student Profile',
          component: () => import('@/views/user-students/profile.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Students',
                'url': '/user/students'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Student View',
            rule: 'user',
            parent: 'user-students'
          }
        },
        {
          path: i18n.t('route.user_profile.url'),
          name: i18n.t('route.user_profile.name'),
          component: () => import('@/views/cam-users/profile.vue'),
          meta: {
            breadcrumb: i18n.t('route.user_profile.meta.breadcrumb'),
            pageTitle: i18n.t('route.user_profile.meta.pageTitle'),
            rule: i18n.t('route.user_profile.meta.rule'),
            parent: 'users'
          }

        },
        {
          path: '/incident/:id',
          name: 'view-incident',
          component: () => import('@/views/incidents/ViewIncident.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', url: '/incidents' },
              { title: 'View', active: true }
            ],
            parent: 'incidents',
            pageTitle: 'Incident View',
            rule: 'manager'
          }
        },

        {
          path: i18n.t('menu.users_profile.url'),
          name: i18n.t('menu.users_profile.name'),
          component: () => import('@/views/cam-users/ViewUserProfile.vue'),
          meta: {
            breadcrumb: i18n.t('menu.users_profile.meta.breadcrumb'),
            pageTitle: i18n.t('menu.users_profile.meta.pageTitle'),
            rule: i18n.t('menu.users_profile.meta.rule')
          }
        },
        {
          path: i18n.t('menu.user_student_cameras.url'),
          name: i18n.t('menu.user_student_cameras.name'),
          component: () => import('@/views/user-students/DataCamList.vue'),
          meta: {
            pageTitle: i18n.t('menu.user_student_cameras.meta.pageTitle'),
            rule: i18n.t('menu.user_student_cameras.meta.rule')
          }
        },

        {
          path: '/dailylogins',
          name: 'Daily Login',
          component: () => import('./views/reports/DailyLogin.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Camera Reports' },
              { title: 'Daily Camera Sessions', active: true }
            ],
            pageTitle: 'Daily Camera Sessions',
            rule: 'manager'
          }
        },
        {
          path: '/dailywatchtime',
          name: 'Daily Watch Time',
          component: () => import('./views/reports/DailyWatch.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Camera Reports' },
              { title: 'Daily Watch Time', active: true }
            ],
            pageTitle: 'Daily Watch Time',
            rule: 'manager'
          }
        },
        {
          path: '/camera-being-watched',
          name: 'Camera Being Watched',
          component: () => import('./views/reports/CameraBeingWatched.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Camera Reports' },
              { title: 'Cameras Being Watched', active: true }
            ],
            pageTitle: 'Cameras Being Watched',
            rule: 'manager'
          }
        },
        {
          path: '/online-contacts-report',
          name: 'Online Contacts',
          component: () => import('./views/reports/OnlineUserReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Camera Reports' },
              { title: 'Online Contacts', active: true }
            ],
            pageTitle: 'Online Contacts',
            rule: 'manager'
          }
        },
        {
          path: '/log-report',
          name: 'Log Report',
          component: () => import('./views/reports/LogReportView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Logs' },
              { title: 'Log Report', active: true }
            ],
            pageTitle: 'Log Report',
            rule: 'manager'
          }
        },
        {
          path: '/activity-report',
          name: 'Activity Report',
          component: () => import('./views/reports/ActivityReportView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Activity Reports' },
              { title: 'Activity Report', active: true }
            ],
            pageTitle: 'Activity Report',
            rule: 'teacher'
          }
        },
        {
          path: '/unsubscribed-emails',
          name: 'Unsubscribed Emails',
          component: () => import('./views/reports/UnsubscribedEmailView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Logs' },
              { title: 'Unsubscribed Emails', active: true }
            ],
            pageTitle: 'Unsubscribed Emails',
            rule: 'manager'
          }
        },
        {
          path: '/unsubscribed-sms',
          name: 'Unsubscribed SMS',
          component: () => import('./views/reports/UnsubscribedSMSView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Logs' },
              { title: 'Unsubscribed SMS', active: true }
            ],
            pageTitle: 'Unsubscribed SMS',
            rule: 'manager'
          }
        },
        {
          path: '/sms-response',
          name: 'SMS Responses',
          component: () => import('./views/reports/SMSResponses.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'SMS Responses', active: true }
            ],
            pageTitle: 'SMS Responses',
            rule: 'manager'
          }
        },
        {
          path: '/newsletters',
          name: 'Newsletters',
          component: () => import('@/views/newsletters/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Newsletters', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/newsletters/:tempId',
          name: 'newsletters-temp',
          component: () => import('@/views/newsletters/template1.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Newsletters', url: '/newsletters' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager',
            parent: 'newsletters'
          }
        },
        {
          path: '/newsletter/new',
          name: 'new-newsletter',
          component: () => import('@/views/newsletters/NewTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Newsletters', url: '/newsletters' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager',
            parent: 'newsletters'
          }
        },
        {
          path: '/templates',
          name: 'Templates',
          component: () => import('@/views/newsletters/DataListTemp.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Newsletters Templates', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/newsletters/:is_temp/:tempId',
          name: 'newsletters-templates',
          component: () => import('@/views/newsletters/template1.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communicate' },
              { title: 'Newsletters Templates', url: '/templates' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin',
            parent: 'Newsletters Templates'
          }
        },
        {
          path: '/newsletter/:is_temp/new',
          name: 'new-newsletter-template',
          component: () => import('@/views/newsletters/NewTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', url: '/templates' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin',
            parent: 'Newsletters Templates'
          }
        },
        {
          path: '/permissions',
          name: 'permissions',
          component: () => import('@/views/permissions/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Permissions Management', url: '/permissions', active: true }
            ],
            pageTitle: 'Permissions Management',
            rule: 'kvsupport'
          }
        },
        {
          path: '/navigation',
          name: 'navigation',
          component: () => import('@/views/permissions/DataListNavigations.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Navigation Management', url: '/navigation', active: true }
            ],
            pageTitle: 'Navigation Management',
            rule: 'kvsupport'
          }
        },
        {
          path: '/streamings',
          name: 'streamings',
          component: () => import('@/views/streamings/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Streaming Servers', url: '/streamings', active: true }
            ],
            pageTitle: 'Streaming Servers',
            rule: 'admin'
          }
        },
        {
          path: '/rtsp-servers',
          name: 'rtsp-servers',
          component: () => import('@/views/rtsp-servers/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'RTSP Servers', url: '/rtsp-servers', active: true }
            ],
            pageTitle: 'RTSP Servers',
            rule: 'admin'
          }
        },
        {
          path: '/streaming-servers',
          name: 'streaming-servers',
          component: () => import('@/views/streamings/DataServersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Streaming Servers', url: '/streamings', active: true }
            ],
            pageTitle: 'Streaming Servers',
            rule: 'admin'
          }
        },
        {
          path: '/user/students/check-in-or-out',
          name: 'Check In/Out',
          component: () => import('./views/user-students/DataCheckInOut.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Check In/Out', active: true }
            ],
            pageTitle: 'Check In/Out',
            rule: 'user'
          }
        },
        {
          path: '/student-activity/check-in-or-out',
          name: 'User Check In/Out',
          component: () => import('./views/cam-users/DataCheckInOut.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Check In/Out', active: true }
            ],
            pageTitle: 'Check In/Out',
            rule: 'manager'
          }
        },
        {
          path: '/teacher/students/check-in-or-out',
          name: 'Teacher Check In/Out',
          component: () => import('./views/cam-users/DataCheckInOut.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Check In/Out', active: true }
            ],
            pageTitle: 'Check In/Out',
            rule: 'teacher'
          }
        },
        {
          path: '/room-ratio',
          name: 'room-ratio',
          component: () => import('@/views/room-ratio/RoomRatioData.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Activity Reports' },
              { title: 'Room Ratio', active: true }
            ],
            pageTitle: 'Room Ratio',
            rule: 'manager'
          }
        },

        {
          path: '/attendance',
          name: 'attendance',
          component: () => import('@/views/attendance/AttendanceTabs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attendance KIOSK', active: true }
            ],
            pageTitle: 'Attendance KIOSK',
            rule: 'teacher'
          },
          children: [
            {
              path: 'students',
              name: 'student-attendance',
              component: () => import('@/views/attendance/StudentAttendanceData.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance', url: '/attendance/students' },
                  { title: 'Student Attendance', active: true }
                ],
                pageTitle: 'Student Attendance',
                rule: 'teacher',
                parent: 'attendance'
              }
            },
            {
              path: 'staff',
              name: 'staff-attendance',
              component: () => import('@/views/attendance/StaffAttendanceData.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance', url: '/attendance/students' },
                  { title: 'Staff Attendance', active: true }
                ],
                pageTitle: 'Staff Attendance',
                rule: 'teacher',
                parent: 'attendance'
              }
            },
            {
              path: 'reports',
              name: 'attendance-reports',
              component: () => import('@/views/attendance/AttendanceReports.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance', url: '/attendance/students' },
                  { title: 'Attendance Reports', active: true }
                ],
                pageTitle: 'Attendance Reports',
                rule: 'teacher',
                parent: 'attendance'
              }
            },
            {
              path: 'health-screen',
              name: 'attendance-health-screen',
              component: () => import('@/views/attendance/HealthScreen.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance', url: '/attendance/students' },
                  { title: 'Health Questionnaire', active: true }
                ],
                pageTitle: 'Health Questionnaire',
                rule: 'teacher',
                parent: 'attendance'
              }
            },
            {
              path: 'kiosk',
              name: 'attendance-kiosk',
              component: () => import('@/views/attendance/AttendanceKiosk.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance', url: '/attendance/students' },
                  { title: 'Attendance KIOSK', active: true }
                ],
                pageTitle: 'Attendance KIOSK',
                rule: 'teacher',
                parent: 'attendance'
              }
            }

          ]
        },
        {
          path: '/photos',
          name: 'photos',
          component: () => import('@/views/documents/photos/PhotosTab.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Photos', active: true }
            ],
            pageTitle: 'Files',
            rule: 'teacher'
          },
          children: [
            {
              path: 'students',
              name: 'student-photos',
              component: () => import('@/views/documents/photos/StudentPhotos.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Photos' },
                  { title: 'Student Photos', active: true }
                ],
                pageTitle: 'Photos',
                rule: 'teacher',
                parent: 'photos'
              }
            },
            {
              path: 'staff',
              name: 'staff-photos',
              component: () => import('@/views/documents/photos/StaffPhotos.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Photos' },
                  { title: 'Staff Photos', active: true }
                ],
                pageTitle: 'Photos',
                rule: 'teacher',
                parent: 'photos'
              }
            },
            {
              path: 'facility',
              name: 'facility-photos',
              component: () => import('@/views/documents/photos/FacilityPhotos.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Photos' },
                  { title: 'Facility Photos', active: true }
                ],
                pageTitle: 'Photos',
                rule: 'teacher',
                parent: 'photos'
              }
            }
          ]
        },
        {
          path: '/documents',
          name: 'documents',
          component: () => import('@/views/documents/document/DataListViewDocuments.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Documents', active: true }
            ],
            pageTitle: 'Documents',
            rule: 'teacher'
          },
          children: []
        },
        {
          path: '/files/others',
          name: 'other-documents',
          component: () => import('@/views/documents/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Other Files', active: true }
            ],
            pageTitle: 'Other Files',
            rule: 'teacher'
          }
        },

        {
          path: '/forms',
          name: 'Forms',
          component: () => import('@/views/forms/FormsTab.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Forms', active: true }
            ],
            pageTitle: 'Forms',
            rule: 'teacher'
          },
          children: [
            {
              path: 'web-forms',
              name: 'web-forms',
              component: () => import('@/views/forms/DataListView.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Forms' },
                  { title: 'Web Forms', active: true }

                ],
                pageTitle: 'Web Forms',
                rule: 'teacher',
                parent: 'forms'
              }
            },
            {
              path: 'printed-forms',
              name: 'printed-forms',
              component: () => import('@/views/documents/PrintedForms.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Forms' },
                  { title: 'Printed Forms', active: true }
                ],
                pageTitle: 'Printed Forms',
                rule: 'teacher',
                parent: 'forms'
              }

            }
          ]
        },
        {
          path: 'printed-form/:formId',
          name: 'printed-form',
          component: () => import('@/views/forms/PrintedFormsTab.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Forms' },
              { title: 'Printed Forms', url: '/forms/printed-forms' },
              { title: 'Entries', active: true }
            ],
            pageTitle: 'Printed Form',
            rule: 'teacher',
            parent: 'printed-forms'
          },
          children: [
            {
              path: 'manage_entries',
              name: 'Printed Form Entries',
              component: () => import('@/views/documents/ViewFormSubmissions.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Forms' },
                  { title: 'Printed Forms', url: '/forms/printed-forms' },
                  { title: 'Entries', active: true }
                ],
                pageTitle: 'Printed Form',
                parent: 'printed-forms',
                rule: 'manager'
              }
            },
            {
              path: 'details',
              name: 'Printed Form Details',
              component: () => import('@/views/forms/PrintedFormDetails.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Forms' },
                  { title: 'Printed Forms', url: '/forms/printed-forms' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Printed Form',
                parent: 'printed-forms',
                rule: 'manager'
              }
            }
          ]
        },
        {
          path: 'form-details/:formId',
          name: 'form-form',
          component: () => import('@/views/documents/ViewFormDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Forms' },
              { title: 'Printed Forms', url: '/forms/printed-forms' },
              { title: 'Form Details', active: true }
            ],
            pageTitle: 'Form Details',
            rule: 'teacher',
            parent: 'printed-forms'
          }
        },
        {
          path: '/calendar',
          name: 'calendar',
          component: () => import('@/views/calendar/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Calendar', active: true }
            ],
            pageTitle: 'Calendar',
            rule: 'teacher'
          }
        },
        {
          path: '/food-menu',
          name: 'food-menu',
          component: () => import('@/views/food-menu/testing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Food Menu', active: true }
            ],
            pageTitle: 'Food Menu',
            rule: 'teacher'
          }
        },
        {
          path: '/student-schedules',
          name: 'Student Schedules',
          component: () => import('@/views/schedule-module/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Schedules', active: true }
            ],
            pageTitle: 'Schedules',
            rule: 'teacher'
          }
        },
        {
          path: '/attendance-summary',
          name: 'Attendance Summary',
          component: () => import('@/views/TimeClockReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Attendance Reports' },
              { title: 'Attendance Summary', active: true }
            ],
            pageTitle: 'Attendance Summary',
            rule: 'teacher'
          }
        },
        {
          path: '/staff-hours',
          name: 'Staff Hours',
          component: () => import('@/views/reports/StaffHoursReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Attendance Reports' },
              { title: 'Staff Hours', active: true }
            ],
            pageTitle: 'Staff Hours',
            rule: 'manager'
          }
        },
        {
          path: '/staff-time-tracking',
          name: 'Staff Time Tracking',
          component: () => import('@/views/reports/StaffTimeTrackingReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Attendance Reports' },
              { title: 'Time Tracking', active: true }
            ],
            pageTitle: 'Time Tracking',
            rule: 'manager'
          }
        },
        {
          path: '/student-daily-hours',
          name: 'Daily Student Attendance',
          component: () => import('@/views/reports/StudentDailyHoursReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Attendance Reports' },
              { title: 'Daily Student Attendance', active: true }
            ],
            pageTitle: 'Daily Student Attendance',
            rule: 'manager'
          }
        },
        {
          path: '/student-hours',
          name: 'Student Hours',
          component: () => import('@/views/reports/StudentHoursReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Attendance Reports' },
              { title: 'Student Hours', active: true }
            ],
            pageTitle: 'Student Hours',
            rule: 'manager'
          }
        },
        {
          path: '/student-attendance-report',
          name: 'Student Attendance Report',
          component: () => import('@/views/reports/StudentAttendanceReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Attendance Reports' },
              { title: 'Student Attendance Report', active: true }
            ],
            pageTitle: 'Student Attendance Report',
            rule: 'teacher'
          }
        },
        {
          path: '/forms',
          name: 'forms',
          component: () => import('@/views/forms/DataListView.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Forms', active: true }
            ],
            pageTitle: 'Forms',
            rule: 'teacher'
          }
        },
        {
          path: '/shared/forms',
          name: 'staff forms',
          component: () => import('@/views/forms/StaffFormsList.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Requests', active: true }
            ],
            pageTitle: 'Form Requests',
            rule: 'teacher'
          }
        },
        {
          path: '/user/students/documents',
          name: 'User Documents',
          component: () => import('@/views/documents/UserSharedDocumentStudents.vue'),

          meta: {
            pageTitle: 'Documents',
            rule: 'user'
          }
        },
        {
          path: '/user/students/:studentId/documents',
          name: 'User Student Documents',
          component: () => import('@/views/documents/UserDocumentList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Documents', url: '/user/students/documents' },
              {
                'title': 'Documents',
                'url': '/user/students/documents'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Documents',
            rule: 'user',
            parent: 'documents'
          }
        },
        {
          path: '/teacher/documents',
          name: 'Teacher Documents',
          component: () => import('@/views/documents/UserDocumentList.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documents', active: true }
            ],
            pageTitle: 'Documents',
            rule: 'teacher'
          }
        },
        {
          path: '/documents',
          name: 'Documents',
          component: () => import('@/views/documents/DataListView.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documents', active: true }
            ],
            pageTitle: 'Documents',
            rule: 'teacher'
          }
        },


        {
          path: '/document/:documentId',
          name: 'Document View',
          component: () => import('@/views/documents/document/DocumentTab.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Document', url: '/documents' },
              { title: 'Details', active: true }
            ],
            pageTitle: 'Document',
            rule: 'teacher',
            parent: 'documents'
          },
          children: [
            {
              path: 'manage_entries',
              name: 'Document Entries',
              component: () => import('@/views/documents/document/SignedDocumentEntries.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Documents', url: '/documents' },
                  { title: 'Entries', active: true }
                ],
                pageTitle: 'Document',
                parent: 'documents',
                rule: 'manager'
              }
            },
            {
              path: 'details',
              name: 'Document Details',
              component: () => import('@/views/documents/FileDetailsView.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Documents', url: '/documents' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Document',
                parent: 'documents',
                rule: 'manager'
              }
            }
          ]
        },
        {
          path: '/others/:otherId',
          name: 'Others View',
          component: () => import('@/views/documents/OtherFilesTab.vue'),


          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files' },
              { title: 'Others', url: '/files/others' },
              { title: 'Details', active: true }
            ],
            pageTitle: 'Other Details',
            rule: 'teacher',
            parent: 'others'
          },
          children: [

            {
              path: 'details',
              name: 'Others Details',
              component: () => import('@/views/documents/OtherFilesDetailView.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Files' },
                  { title: 'Others', url: '/files/others' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Other Details',
                parent: 'others',
                rule: 'manager'
              }
            }
          ]

        },
        {
          path: '/user/students/:studentId/files',
          name: 'User files',
          component: () => import('@/views/forms/StudentFormList.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Form Requests',
                'url': '/user/students/forms'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Form Requests',
            rule: 'user',
            parent: 'forms'
          }
        },
        {
          path: '/user/students/forms',
          name: 'User Forms',
          component: () => import('@/views/pages/UserStudentSharedForm.vue'),

          meta: {

            pageTitle: 'Form Requests',
            rule: 'user'

          }
        },
        {
          path: 'report-balance',
          name: 'Balance Report',
          component: () => import('@/views/billing/StudentBalanceReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Billing Reports', url: '/billing/billing-reports' },
              { title: 'Student Balance Report', active: true }
            ],
            pageTitle: ' Student Balance Report',
            rule: 'admin'
          }
        },
        {
          path: 'report-transactions',
          name: 'Transactions Report',
          component: () => import('@/views/billing/StudentTransactionReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Billing Reports', url: '/billing/billing-reports' },
              { title: 'Transactions Report', active: true }
            ],
            pageTitle: 'Transactions Report',
            rule: 'admin'
          }
        },
        {
          path: 'report-invoices',
          name: 'Invoices Report',
          component: () => import('@/views/billing/StudentInvoiceReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Billing Reports', url: '/billing/billing-reports' },
              { title: 'Invoices Report', active: true }
            ],
            pageTitle: 'Invoices Report',
            rule: 'admin'
          }
        },
        {
          path: 'report-payments',
          name: 'Payments & Credits Report',
          component: () => import('@/views/billing/StudentPaymentReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Billing Reports', url: '/billing/billing-reports' },
              { title: 'Payments & Credits Report', active: true }
            ],
            pageTitle: 'Payments & Credits Report',
            rule: 'admin'
          }
        },
        {
          path: 'report-billing-summary',
          name: 'Billing Summary Report',
          component: () => import('@/views/billing/BillingSummaryReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Billing Reports', url: '/billing/billing-reports' },
              { title: 'Billing Summary Report', active: true }
            ],
            pageTitle: 'Billing Summary Report',
            rule: 'admin'
          }
        },

        {
          path: '/relationships',
          name: 'Relationships',
          component: () => import('./views/relationships/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Relationships Management', active: true }
            ],
            pageTitle: 'Relationships Management',
            rule: 'manager'
          }
        },
        {
          path: '/immunizations',
          name: 'immunizations',
          component: () => import('@/views/immunizations/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings' },
              { title: 'Immunizations', active: true }
            ],
            pageTitle: 'Immunizations',
            rule: 'kvsupport'
          }
        },
        {
          path: '/blogs',
          name: 'blogs',
          redirect: '/blogs/posts',
          component: () => import('@/views/blogs/BlogsTabs.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Blog', active: true }
            ],
            pageTitle: 'Blog',
            rule: 'blog',
            parent: 'blog'
          },
          children: [
            {
              path: 'posts',
              name: 'Posts',
              component: () => import('@/views/blogs/DataListListView.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Blog' },
                  { title: 'Posts', active: true }
                ],
                pageTitle: 'Blog',
                parent: 'blog',
                rule: 'blog'
              }
            },
            {
              path: 'categories',
              name: 'Blog Category Management',
              component: () => import('@/views/blogs/CategoryManagement.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Blog' },
                  { title: 'Categories', active: true }
                ],
                pageTitle: 'Blog',
                parent: 'blog',
                rule: 'blog'
              }
            },
            {
              path: 'api_integration',
              name: 'Blog Integration',
              component: () => import('@/views/blogs/DataIntegrationSidebar.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Blog' },
                  { title: 'Api Integration', active: true }
                ],
                pageTitle: 'Blog',
                parent: 'blog',
                rule: 'blog'
              }
            },
            {
              path: 'settings',
              name: 'Blog Settings',
              component: () => import('@/views/blogs/DataSettingSidebar.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Blog' },
                  { title: 'Settings', active: true }
                ],
                pageTitle: 'Blog',
                parent: 'blog',
                rule: 'blog'
              }
            }

          ]
        },
        {
          path: '/submissions',
          name: 'Submissions',
          component: () => import('@/views/suforms/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Submissions', active: true }
            ],
            pageTitle: 'Submissions',
            rule: 'manager'
          }
        },
        {
          path: 'billing',
          name: 'billing',
          component: () => import('@/views/billing/BillingTabs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing', active: true }
            ],
            pageTitle: 'Billing',
            rule: 'admin'
          },
          children: [
            {
              path: 'quick-links',
              name: 'billing-quick-links',
              component: () => import('@/views/billing/QuickLinks.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Quick Links', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing'
              }
            },
            {
              path: 'overview',
              name: 'billing-overview',
              redirect: '/billing/overview/unpaid',
              component: () => import('@/views/billing/DataBillingOverview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Overview', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing'
              },
              children: [
                {
                  path: 'unpaid',
                  name: 'billing-unpaid',
                  component: () => import('@/views/billing/DataListListView.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Billing', url: '/billing/overview' },
                      { title: 'Overview', url: '/billing/overview' },
                      { title: 'Unpaid Invoices', active: true }
                    ],
                    pageTitle: 'Billing',
                    rule: 'admin',
                    parent: 'billing-overview'
                  }
                },
                {
                  path: 'payments',
                  name: 'billing-payments',
                  component: () => import('@/views/billing/DataListPayments.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Billing', url: '/billing/overview' },
                      { title: 'Overview', url: '/billing/overview' },
                      { title: 'Payments', active: true }
                    ],
                    pageTitle: 'Billing',
                    rule: 'admin',
                    parent: 'billing-overview'
                  }
                }
              ]

            },

            {
              path: 'students',
              name: 'billing-students',
              redirect: '/billing/students/overview',
              component: () => import('@/views/billing/DataStudentsList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing'
              },
              children: [
                {
                  path: 'overview',
                  name: 'billing-students-overview',
                  component: () => import('@/views/billing/StudentOverviewList.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Billing', url: '/billing/overview' },
                      { title: 'Students', url: '/billing/students' },
                      { title: 'Overview', active: true }
                    ],
                    pageTitle: 'Billing',
                    rule: 'admin',
                    parent: 'billing-students'
                  }
                },
                {
                  path: 'plans',
                  name: 'billing-students-plans',
                  component: () => import('@/views/billing/DataListPlanView.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Billing', url: '/billing/overview' },
                      { title: 'Students', url: '/billing/students' },
                      { title: 'Students with plans', active: true }

                    ],
                    pageTitle: 'Billing',
                    rule: 'admin',
                    parent: 'billing-students'
                  }
                }
              ]
            },
            {
              path: 'subsidies',
              name: 'billing-subsidies',
              component: () => import('@/views/billing/agency/DataSubsidiesList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Subsidies', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing'
              }
            },
            {
              path: 'settings',
              name: 'billing-settings',
              component: () => import('@/views/billing/SettingsList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing'
              }
            },
            {
              path: 'settings/manage-presets',
              name: 'billing-manage-presets',
              component: () => import('@/views/billing/ManagePresetList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', url: '/billing/settings' },
                  { title: 'Manage Presets', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            },
            {
              path: 'settings/variable-charges',
              name: 'billing-variable-charges',
              component: () => import('@/views/billing/VariableCharges.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', url: '/billing/settings' },
                  { title: 'Variable Charges', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            },

            {
              path: 'settings/categories',
              name: 'billing-categories',
              component: () => import('@/views/billing/Categories.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', url: '/billing/settings' },
                  { title: 'Categories', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            },
            {
              path: 'settings/plan-templates',
              name: 'billing-plan-templates',
              component: () => import('@/views/billing/DataPlanTemplates.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', url: '/billing/settings' },
                  { title: 'Plan Templates', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            },
            {
              path: 'settings/late-fees',
              name: 'billing-settings-late-fees',
              component: () => import('@/views/billing/LateFeeSettings.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', url: '/billing/settings' },
                  { title: 'Late Payment Fees', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            },
            {
              path: 'settings/service-fees',
              name: 'billing-service-fees',
              component: () => import('@/views/billing/ServiceFees.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Settings', url: '/billing/settings' },
                  { title: 'Service Fees', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            },

            {
              path: 'billing-reports',
              name: 'billing-reports',
              component: () => import('@/views/billing/ReportsList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Reports', active: true }

                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent: 'billing-settings'
              }
            }
          ]
        },
        {
          path: '/home',
          name: 'user-dashboard',
          component: () => import('@/views/user-students/UserDashboard.vue'),
          meta: {
            rule: 'user'

          }
        },
        {
          path: '/dashboard',
          name: 'teacher-dashboard',
          component: () => import('@/views/Home.vue'),
          meta: {
            rule: 'teacher',
            parent: 'dashboard'
          }
        },
        {
          path: '/user/students/billing',
          name: 'user-billing',
          component: () => import('@/views/billing/UserBillingView.vue'),
          meta: {
            rule: 'user',
            pageTitle: 'Payments'
          }
        },
        {
          path: '/user/students/billing2',
          name: 'user-billing2',
          component: () => import('@/views/billing/UserBillingView2.vue'),
          meta: {
            rule: 'user',
            pageTitle: 'Payments'
          }

        },
        {
          path: '/files/student/:studentId/form/:formId/submission',
          name: 'Form Submission',
          component: () => import('@/views/pages/FormSubmissionPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },

              { title: 'Form Submission', active: true }
            ],
            pageTitle: 'Form Submission',
            rule: 'user'
          }
        },
        {
          path: '/files/student/:studentId/form/:formId/document/submission',
          name: 'User Form Submission',
          component: () => import('@/views/pages/PdfFormSubmissionPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Requests', url: '/user/students/forms' },
              { title: 'Form Submission', active: true }
            ],
            pageTitle: 'Form Submission',
            rule: 'user',
            parent: 'forms'
          }
        },
        {
          path: '/files/form/:formId/submission',
          name: 'Staff Form Submission',
          component: () => import('@/views/pages/PdfFormStaffSubmission.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Submission', active: true }
            ],
            pageTitle: 'Form Submission',
            rule: 'teacher',
            parent: 'forms'
          }
        },


        {
          path: '/portfolios',
          name: 'portfolios',
          component: () => import('@/views/learning/Portfolio.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning', active: true },
              { title: 'Portfolios', active: true }
            ],
            pageTitle: 'Portfolios',
            rule: 'teacher'
          }
        },
        {
          path: 'students/portfolio_preview/:portfolioId',
          name: 'portfolio_preview',
          component: () => import('@/views/learning/PortfolioPreview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Students', url: '/user/students' },
              { title: 'Portfolio' },
              { title: 'Portfolio Preview', active: true }
            ],
            pageTitle: 'Portfolio Preview',
            rule: 'user',
            parent: 'user-students'
          }
        },


        {
          path: '/learning',
          name: 'Learning Main',
          redirect: '/learning/lesson_plans',
          component: () => import('@/views/learning/LearningTabs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning', active: true }
            ],
            pageTitle: 'Learning',
            parent: 'learning',
            rule: 'teacher'
          },
          children: [

            {
              path: 'lesson_plans',
              name: 'Learning Lesson Plans',
              redirect: '/learning/lesson_plans/room_plans',
              component: () => import('@/views/learning/LearningPlanTabs.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Lesson Plans', active: true }
                ],
                pageTitle: 'Learning',
                parent: 'Learning',
                rule: 'teacher'
              },
              children: [
                {
                  path: 'room_plans',
                  name: 'Learning Room Plans',
                  component: () => import('@/views/learning/LearningRoomPlan.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Learning' },
                      { title: 'Room Plans', active: true }
                    ],
                    pageTitle: 'Learning',
                    parent: 'Learning',
                    rule: 'teacher'
                  }
                },
                {
                  path: 'templates',
                  name: 'Learning Templates',
                  component: () => import('@/views/learning/DataLessonPlan.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Learning' },
                      { title: 'Templates', active: true }
                    ],
                    pageTitle: 'Learning',
                    parent: 'Learning',
                    rule: 'teacher'
                  }
                }
              ]
            },
            {
              path: 'learning_activities',
              name: 'Learning Activities',
              component: () => import('@/views/learning/ViewLearning.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Learning Activities', active: true }
                ],
                pageTitle: 'Learning',
                parent: 'Learning',
                rule: 'teacher'
              }
            },
            {
              path: 'learning',
              name: 'Learning',
              redirect: '/learning/learning/learning_frameworks',
              component: () => import('@/views/learning/LearningChildTabs.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning', active: true }
                ],
                parent: 'Learning',
                rule: 'admin'
              },
              children: [

                {
                  path: 'learning_frameworks',
                  name: 'Learning Frameworks',
                  component: () => import('./views/Settings/Frameworks'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Learning' },
                      { title: 'Learning Frameworks', active: true }
                    ],
                    pageTitle: 'Learning',
                    parent: 'Learning',
                    rule: 'manager'
                  }
                },
                {
                  path: 'learning_skills',
                  name: 'Learning Skills',
                  component: () => import('./views/learning/LearningSkills'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Learning' },
                      { title: 'Learning Skills', active: true }
                    ],
                    pageTitle: 'Learning',
                    parent: 'Learning',
                    rule: 'manager'
                  }
                }

              ]
            },

            {
              path: 'portfolios',
              name: 'Portfolios',
              component: () => import('@/views/learning/Portfolio.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Student Portfolios', active: true }
                ],
                pageTitle: 'Learning',
                parent: 'Learning',
                rule: 'teacher'
              }
            },
            {
              path: '/learning/portfolios/:portfolioId/edit',
              name: 'Portfolio Builder',
              component: () => import('@/views/learning/PortfolioBuilderPage.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Student Portfolios', url: '/learning/portfolios/' },
                  { title: 'Portfolio Builder', active: true }

                ],
                pageTitle: 'Learning',
                parent: 'Learning',
                rule: 'teacher'
              }
            },
            {
              path: '/learning/portfolios/portfolio_preview/:portfolioId',
              name: 'Portfolio Preview',
              component: () => import('@/views/learning/PortfolioPreview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Student Portfolios', url: '/learning/portfolios/' },
                  { title: 'Portfolio Preview', active: true }
                ],
                pageTitle: 'Portfolio Preview',
                rule: 'teacher',
                parent: 'Learning'
              }
            },
            {
              path: '/learning/lesson_plans/room_plans/:roomId/edit',
              name: 'Edit Room Plan',
              component: () => import('@/views/learning/EditRoomPlanPage.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Room Plans', url: '/learning/lesson_plans/room_plans' },
                  { title: 'Edit Room Plan', active: true }

                ],
                pageTitle: 'Learning',
                parent: 'Learning',
                rule: 'teacher'
              }
            },
            {
              path: '/learning/lesson_plans/templates/:templateId/edit',
              name: 'Edit Lesson Plan',
              component: () => import('@/views/learning/EditLessonPlanPage.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Learning' },
                  { title: 'Templates', url: '/learning/lesson_plans/templates' },
                  { title: 'Edit Lesson Plan', active: true }

                ],
                pageTitle: 'Learning',
                parent: 'Learning',
                rule: 'teacher'
              }
            }

          ]
        },

        {
          path: '/learning/learning_activities/learning_view',
          name: 'add_activity',
          component: () => import('@/views/learning/DataViewActivity.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning' },
              { title: 'Learning Activities', url: '/learning/learning_activities' },
              { title: 'Add Activity', active: true }
            ],
            pageTitle: 'Learning',
            rule: 'teacher',
            parent: 'Learning'
          }
        },
        {
          path: '/learning/learning_activities/:activityId/edit',
          name: 'edit_activity',
          component: () => import('@/views/learning/EditLearningActivityPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning' },
              { title: 'Learning Activities', url: '/learning/learning_activities' },
              { title: 'Edit Activity', active: true }
            ],
            pageTitle: 'Learning',
            rule: 'teacher',
            parent: 'Learning'
          }
        },

        {
          path: '/learning/learning/learning_frameworks/import-framework',
          name: 'import_framework',
          component: () => import('@/views/learning/ImportLearningData.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning' },
              { title: 'Learning Frameworks', url: '/learning/learning/learning_frameworks' },
              { title: 'Import Frameworks', active: true }
            ],
            pageTitle: 'Learning',
            rule: 'admin',
            parent: 'Learning'
          }
        },


        {
          path: '/web-form/:formId',
          name: 'Custom Web Form Main',
          component: () => import('@/views/forms/CustomFormTabs.vue'),
          meta: {
            parent: 'web-forms',
            rule: 'user'
          },
          children: [
            {
              path: 'manage_entries',
              name: 'Custom Form Entries',
              component: () => import('@/views/forms/CustomFormEntries.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              }
            },
            {
              path: 'edit',
              name: 'Edit Custom Form',
              component: () => import('@/views/forms/FormViewPage.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              }
            },
            {
              path: 'details',
              name: 'Form Details',
              component: () => import('@/views/forms/FormDetails.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              }
            },
            {
              path: 'notifications',
              name: 'Custom Form Notification',
              redirect: '/web-form/:formId/notifications/settings',
              component: () => import('@/views/forms/NotificationTabs.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              },
              children: [
                {
                  path: 'settings',
                  name: 'Custom Form Notification Settings',
                  component: () => import('@/views/forms/CustomFormNotification.vue'),
                  meta: {
                    parent: 'web-forms',
                    rule: 'manager'
                  }
                },
                {
                  path: 'logs',
                  name: 'Custom Form Notification Logs',
                  component: () => import('@/views/forms/CustomFormNotificationLogs.vue'),
                  meta: {
                    parent: 'web-forms',
                    rule: 'manager'
                  }
                }
              ]
            },


            {
              path: 'automations',
              name: 'Custom Form Automation',
              component: () => import('@/views/forms/CustomFormAutomationTabs.vue'),
              redirect: '/web-form/:formId/automations/settings',
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              },
              children: [
                {
                  path: 'settings',
                  name: 'Custom Form Automation Settings',
                  component: () => import('@/views/forms/CustomFormAutomation.vue'),
                  meta: {
                    parent: 'web-forms',
                    rule: 'manager'
                  }
                },
                {
                  path: 'logs',
                  name: 'Custom Form Automation Logs',
                  component: () => import('@/views/forms/CustomFormAutomationLogs.vue'),
                  meta: {
                    parent: 'web-forms',
                    rule: 'manager'
                  }
                }
              ]
            },
            {
              path: ':entryId/view_entry',
              name: 'Custom Form Entry View',
              component: () => import('@/views/forms/CustomFormEntryView.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              }
            },
            {
              path: ':Id/entries',
              name: 'External Form Entries',
              component: () => import('@/views/forms/EntriesFormBuilder.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              }
            },
            {
              path: ':entryId/entry_view',
              name: 'External Form Entry View',
              component: () => import('@/views/forms/EntryView.vue'),
              meta: {
                parent: 'web-forms',
                rule: 'manager'
              }
            }
          ]
        },

        {
          path: 'web-form/:formId',
          name: 'Shared Form',
          component: () => import('@/views/forms/SharedForms.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form View', active: true }
            ],
            pageTitle: 'Form View',
            rule: 'user'
          }
        },
        {
          path: 'web-form/:Id/:formId/:entryId/entry',
          name: 'View Entry',
          component: () => import('@/views/forms/EntryView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Forms' },
              { title: 'Web Forms', url: '/forms/web-forms' },
              { title: 'Form View' },
              { title: 'Entry View', active: true }
            ],
            pageTitle: 'Entry View',
            parent: 'web-forms',
            rule: 'user'
          }
        },
        {
          path: 'web-form/:formId/share',
          name: 'Share Parent Form',
          component: () => import('@/views/forms/ShareParents.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form', active: true }
            ],
            pageTitle: 'Form',
            rule: 'user'
          }
        },
        {
          path: 'students/:studentId/form/review/:formId',
          name: 'Review',
          component: () => import('@/views/forms/ReviewSubmissions.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Review Submission', active: true }
            ],
            pageTitle: 'Review Submission',
            rule: 'user'
          }
        },
        {
          path: '/billing/student/:studentId',
          name: 'billing-student',
          component: () => import('@/views/billing/StudentView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing', url: '/billing/overview' },
              { title: 'Students', url: '/billing/students' },
              { title: 'Student Account', active: true }
            ],
            parent: 'billing-students',
            pageTitle: 'Student Account',
            rule: 'manager'
          },
          children: [
            {
              path: '/billing/student/overview/:studentId',
              redirect: '/billing/student/open-invoices/:studentId',
              name: 'student-overview',
              component: () => import('@/views/billing/StudentBillingOverview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account' },
                  { title: 'Current Activity', active: true }

                ],
                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              },
              children: [
                {
                  path: '/billing/student/open-invoices/:studentId',
                  name: 'student-open-invoices',
                  component: () => import('@/views/billing/StudentOpenInvoices.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Billing', url: '/billing/overview' },
                      { title: 'Students', url: '/billing/students' },
                      { title: 'Student Account' },
                      { title: 'Open Invoices', active: true }
                    ],
                    parent: 'billing-students',
                    pageTitle: 'Student Account',
                    rule: 'manager'
                  }
                },
                {
                  path: '/billing/student/available-credits/:studentId',
                  name: 'student-available-credits',
                  component: () => import('@/views/billing/StudentCredits.vue'),
                  meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Billing', url: '/billing/overview' },
                      { title: 'Students', url: '/billing/students' },
                      { title: 'Student Account' },
                      { title: 'Available Credits & Payments', active: true }
                    ],
                    parent: 'billing-students',
                    pageTitle: 'Student Account',
                    rule: 'manager'
                  }

                }
              ]
            },
            {
              path: '/billing/student/invoices/:studentId',
              name: 'student-invoices',
              component: () => import('@/views/billing/StudentInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account' },
                  { title: 'All Invoices', active: true }
                ],
                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/payments/:studentId',
              name: 'student-payments',
              component: () => import('@/views/billing/StudentPayments.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account' },
                  { title: 'All Payments', active: true }
                ],
                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/upcoming-invoices/:studentId',
              name: 'student-upcoming-invoices',
              component: () => import('@/views/billing/StudentUpcomingInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account' },
                  { title: 'Unprocessed Invoice', active: true }
                ],

                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/account-detail/:studentId',
              name: 'student-account-detail',
              component: () => import('@/views/billing/StudentAccountDetails.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account', active: true }
                ],
                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/plans-detail/:studentId',
              name: 'student-plans-detail',
              component: () => import('@/views/billing/StudentPlans.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account' },
                  { title: 'Billing Plans', active: true }
                ],
                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/payers-detail/:studentId',
              name: 'student-payers-detail',
              component: () => import('@/views/billing/StudentPayers.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Students', url: '/billing/students' },
                  { title: 'Student Account' },
                  { title: 'Payers', active: true }
                ],
                parent: 'billing-students',
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            }
          ]
        },
        {
          path: '/billing/agency/:agencyId',
          name: 'billing-agency',
          component: () => import('@/views/billing/agency/AgencyView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing', url: '/billing/overview' },
              { title: 'Agency Account', active: true }
            ],
            pageTitle: 'Agency Account',
            rule: 'manager',
            parent: 'billing-subsidies'
          },
          children: [
            {
              path: '/billing/agency/overview/:agencyId',
              name: 'agency-overview',
              component: () => import('@/views/billing/agency/AgencyOverview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager',
                parent: 'billing-subsidies'
              }

            },
            {
              path: '/billing/agency/invoices/:agencyId',
              name: 'agency-invoices',
              component: () => import('@/views/billing/agency/AgencyInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager',
                parent: 'billing-subsidies'
              }

            },
            {
              path: '/billing/agency/payments/:agencyId',
              name: 'agency-payments',
              component: () => import('@/views/billing/agency/AgencyPayments.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager',
                parent: 'billing-subsidies'
              }

            },
            {
              path: '/billing/agency/students/:agencyId',
              name: 'agency-students',
              component: () => import('@/views/billing/agency/AgencyStudents.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager',
                parent: 'billing-subsidies'
              }

            },
            {
              path: '/billing/agency/info/:agencyId',
              name: 'agency-info',
              component: () => import('@/views/billing/agency/AgencyInfo.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager',
                parent: 'billing-subsidies'
              }

            },
            {
              path: '/billing/agency/upcoming-invoices/:agencyId',
              name: 'agency-upcoming-invoices',
              component: () => import('@/views/billing/agency/UpcommingInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager',
                parent: 'billing-subsidies'
              }

            }
          ]
        },
        {
          path: '/centers-plans',
          name: 'Center Billing Plans',
          component: () => import('@/views/aws-centers/billing/plans/BillingPlans.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing Plans', active: true }
            ],
            pageTitle: 'Billing Plans',
            rule: 'admin'
          }
        },
        {
          path: '/centers-invoices',
          name: 'Center Invoices',
          component: () => import('@/views/aws-centers/invoices/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Invoices', active: true }
            ],
            pageTitle: 'Invoices',
            rule: 'admin'
          }
        },
        {
          path: '/centers-payments',
          name: 'Center Payments',
          component: () => import('@/views/aws-centers/payments/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Payments', active: true }
            ],
            pageTitle: 'Payments',
            rule: 'admin'
          }
        },
        {
          path: 'kidsvision-plan',
          name: 'kidsvision-plan',
          component: () => import('@/views/aws-centers/Subscription.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'My kidsVision Plan', active: true }
            ],
            pageTitle: 'My kidsVision Plan',
            rule: 'admin'
          }
        },
        {
          path: 'parent-directory',
          name: 'parent-directory',
          component: () => import('@/views/cam-users/DataParentDirectory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Parent Directory', active: true }
            ],
            pageTitle: 'Parent Directory',
            rule: 'user'
          }
        }
      ]
    },


    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [


        {
          path: 'login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'register/:code?',
          name: 'page-register',
          component: () => import('@/views/pages/Register'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'email-confirmation',
          name: 'email-confirmation',
          component: () => import('@/views/pages/EmailConfirmationPage'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'verify-autologin/:token?',
          name: 'verify-autologin',
          component: () => import('@/views/pages/VerifyAutoLogin'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'verify-email/:pin_time?',
          name: 'verify-email',
          component: () => import('@/views/pages/VerifyEmailPage'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'viue/:pin_time',
          name: 'viue',
          component: () => import('@/views/pages/VerifyInvitedUserEmail'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'viup/:pin_time',
          name: 'viup',
          component: () => import('@/views/pages/VerifyInvitedUserPhone'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'password/reset/:token?',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'approve-user/:token',
          name: 'approve-user',
          component: () => import('@/views/pages/ApproveUser'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'resend-confirmation-email',
          name: 'resend-confirmation-email',
          component: () => import('@/views/pages/ResendTokenEmail'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/pages/404-error',
          name: 'site-error-404',
          component: () => import('@/views/pages/SiteError404.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'unsubscribe/:token?',
          name: 'unsubscribe email',
          component: () => import('@/views/pages/UnsubscribeEmail.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'time-clock-page/:location',
          name: 'Time Clock Screen',
          component: () => import('@/views/pages/TimeclockScreen.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'demo/:action?',
          name: 'Demo',
          component: () => import('@/views/customer-signup/requestDemo.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'customer-signup/:action?',
          name: 'Customers Signup',
          component: () => import('@/views/customer-signup/customerSignup.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'packages',
          name: 'packages',
          component: () => import('@/views/customer-signup/packagesPlan.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'customer-payment',
          name: 'customer-payment',
          component: () => import('@/views/customer-signup/paymentScreen.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'customer-center-setup/:token?',
          name: 'customer-center-setup',
          component: () => import('@/views/customer-signup/paymentSuccessPage.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'web-form/:formId/view',
          name: 'Form Preview',
          component: () => import('@/views/pages/FormPreviewPage.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/oauth2callback',
          name: 'Google Auth',
          component: () => import('@/views/pages/GoogleAuth.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/googleInt',
          name: 'Google Integration',
          component: () => import('@/views/calendar/GoogleIntegration.vue'),
          meta: {
            rule: 'guest'
          }
        }

      ]
    },

    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})
router.afterEach(() => {

  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }

})


router.beforeEach((to, from, next) => {
  router.app.$nextTick(() => {
    if (from?.name) {
      router.app.$vs.loading({
        type: 'sound'
      })
    }
    next()
  })
})

router.afterEach(() => {
  router.app.$nextTick(() => {

    router.app.$vs.loading.close()

  })
})


export default router
